import { useState, useEffect, useCallback } from 'react'

export const useGetPaymentMethods = () => {
  const [paymentMethods, setPaymentMethods] = useState<null | any>(null)
  const [loading, setLoading] = useState<boolean>(true)

  const refetch = useCallback(async () => {
    setLoading(true)
    const res = await getPaymentMethods()
    if (res) {
      setPaymentMethods(res)
    }

    setLoading(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    refetch()
  }, [refetch])

  return { paymentMethods, loading, refetch }
}

import { IBankAccountModel, routes } from '@linqpal/models'

export const getPaymentMethods = async () => {
  try {
    const resp = await routes.company.bankAccounts()
    if (!resp.bankAccounts) return null
    const bankAccountsWithMappedCardIds = resp.bankAccounts.map(
      (bankAccount) => {
        if (bankAccount.paymentMethodType === 'card') {
          bankAccount.accountType = bankAccount.cardMetadata.type
        }
        return bankAccount
      },
    )
    return bankAccountsWithMappedCardIds as unknown as IBankAccountModel[]
  } catch (err) {
    console.error(err)
    return null
  }
}
